import { Components, Theme } from '@mui/material';

export const MuiPaper: Components<Omit<Theme, 'components'>>['MuiPaper'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      backgroundColor: theme.palette.surfaceContainer.high,
      '--Paper-overlay': 'none !important',
      marginBottom: theme.spacing(2),

      '& .MuiPaper-root': {
        '> .MuiFormControl-root': {
          marginBottom: `${theme.spacing(2)} !important`,
        },
      },

      ...Array.from({ length: 5 }, (_, i) => i + 1).reduce(
        (acc, elevation) => ({
          ...acc,
          [`&.MuiPaper-elevation${elevation}`]: {
            boxShadow: `${theme.shadows[elevation]} !important`,
          },
        }),
        {},
      ),
    }),
  },
};
